import {
  prisma,
  type Prisma,
  type Organization,
  type Event,
  type ServicesQuota,
} from "client";

type TransactionInclude = {
  organization?: Organization;
  event?: Event;
  qouta?: ServicesQuota;
};

export const createTransaction = async (
  data: Prisma.TransactionsCreateInput
) => {
  try {
    const qouta = await prisma.servicesQuota.findFirst({
      where: {
        stripePriceId: data.priceId,
      },
      select: {
        id: true,
      },
    });
    if (!qouta) {
      throw new Error("Quota not found");
    }
    return await prisma.transactions.create({
      data: {
        ...data,
        ...(qouta ? { qouta: { connect: { id: qouta.id } } } : {}),
      },
    });
  } catch (error) {
    console.error("Error creating subscription:", error);
    throw error;
  }
};

export const getTransactionByPriceId = async (priceId: string) => {
  return await prisma.transactions.findFirst({
    where: {
      priceId,
    },
  });
};

export const getTransactionByOrganizationId = async (
  organizationId: string
) => {
  return await prisma.transactions.findFirst({
    where: {
      organizationId,
    },
    include: {
      organization: {
        select: {
          whiteLabelId: true,
          id: true,
        },
      },
    },
    orderBy: {
      createdAt: "desc",
    },
  });
};

export const getTransactionById = async (id: string) => {
  return await prisma.transactions.findUnique({
    where: {
      id,
    },
    include: {
      organization: {
        include: {
          translations: true,
        },
      },
    },
  });
};
export const getTransactionByStripeTransactionId = async (id: string) => {
  return await prisma.transactions.findFirst({
    where: {
      stripeTransactionId: id,
    },
    include: {
      organization: {
        select: {
          whiteLabelId: true,
          id: true,
        },
      },
    },
  });
};

export const getTransactionBySessionId = async (sessionId: string) => {
  return await prisma.transactions.findFirst({
    where: {
      sessionId,
    },
  });
};

export const updateTransaction = async (
  id: string,
  data: Prisma.TransactionsUpdateInput,
  include?: Prisma.TransactionsInclude
) => {
  return await prisma.transactions.update({
    where: { id },
    data,
    include: include as Prisma.TransactionsInclude,
  });
};

export const getAllTransaction = async () => {
  return await prisma.transactions.findMany({
    include: {
      organization: {
        include: {
          translations: true,
        },
      },
    },
    orderBy: {
      createdAt: "desc",
    },
  });
};

export const getTransactionByInvoiceId = async (invoiceId: string) => {
  return await prisma.transactions.findFirst({
    where: {
      OR: [
        {
          stripeLatestInvoiceId: invoiceId,
        },
        {
          sessionId: invoiceId,
        },
      ],
    },
    include: {
      organization: {
        include: {
          translations: true,
        },
      },
    },
  });
};
